export default {
    "title": "Uautorisert",
    "description": "Kontakt administratoren din."
}